(function () {
  "use strict";

// [module] src/runtime/modules/legacy/scripts-cfa/runtime.mjs
function registerLegacyScriptsCfaRuntime() {
  if (window.__sternCfaRuntimeInitialized) {
      return;
  }

  const resolvedJquery = window.jQuery || window.$;
  if (typeof resolvedJquery !== "function") {
      const themeRoot = window.__sternTheme || {};
      if (typeof themeRoot.ensureLegacyJQuery === "function") {
          themeRoot.ensureLegacyJQuery("scripts-cfa-runtime", function (loadedJquery) {
              if (typeof loadedJquery === "function" && !window.__sternCfaRuntimeInitialized) {
                  registerLegacyScriptsCfaRuntime();
              }
          });
      }
      return;
  }

  const $ = resolvedJquery;
  window.__sternCfaRuntimeInitialized = true;

  // Contact-for-availability runtime (route-conditional).
  
  function loadScriptOnce(config) {
      if (window.__sternLoadScriptOnce && typeof window.__sternLoadScriptOnce === "function") {
          return window.__sternLoadScriptOnce(config);
      }
      return Promise.resolve(false);
  }
  
  function getCountryRegionDataUrl() {
      if (
          window.__sternTheme &&
          typeof window.__sternTheme.countryRegionDataUrl === "string" &&
          window.__sternTheme.countryRegionDataUrl.length
      ) {
          return window.__sternTheme.countryRegionDataUrl;
      }
      return "/assets/country-region-data.js";
  }
  
  function loadCountryRegionData() {
      if (Array.isArray(window.countryRegionData) && window.countryRegionData.length) {
          return Promise.resolve(window.countryRegionData);
      }
  
      const countryRegionDataUrl = getCountryRegionDataUrl();
      if (!countryRegionDataUrl) {
          return Promise.resolve([]);
      }
  
      return loadScriptOnce({
          key: "stern-country-region-data",
          url: countryRegionDataUrl,
          scriptAttr: "data-country-region-data"
      })
          .then(() => (
              Array.isArray(window.countryRegionData) ? window.countryRegionData : []
          ))
          .catch(() => []);
  }
  
  function getOptionSelectionUrl() {
      if (
          window.__sternTheme &&
          typeof window.__sternTheme.optionSelectionUrl === "string" &&
          window.__sternTheme.optionSelectionUrl.length
      ) {
          return window.__sternTheme.optionSelectionUrl;
      }
      return "";
  }
  
  function rootNeedsOptionSelection(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      return !!scope.querySelector('form[name="add_to_cart"] select[name="id"]');
  }
  
  function collectCfaRuntimeNodes(rootNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      return {
          scope: scope,
          needsOptionSelection: !!scope.querySelector('form[name="add_to_cart"] select[name="id"]'),
          countrySelects: Array.from(scope.querySelectorAll("select#countrySelect")),
          specificationSelects: Array.from(scope.querySelectorAll("#select")),
          locationSelects: Array.from(scope.querySelectorAll("#location"))
      };
  }
  
  function loadOptionSelectionScriptIfNeeded(rootNode, precheckedNeedsOptionSelection) {
      const needsOptionSelection = precheckedNeedsOptionSelection === true || rootNeedsOptionSelection(rootNode);
      if (!needsOptionSelection) {
          return Promise.resolve(false);
      }
  
      if (window.Shopify && window.Shopify.OptionSelectors) {
          return Promise.resolve(true);
      }
  
      const optionSelectionUrl = getOptionSelectionUrl();
      if (!optionSelectionUrl) {
          return Promise.resolve(false);
      }
  
      return loadScriptOnce({
          key: "stern-option-selection",
          url: optionSelectionUrl,
          scriptAttr: "data-option-selection"
      }).then((loaded) => {
          if (loaded) {
              return true;
          }
          return !!(window.Shopify && window.Shopify.OptionSelectors);
      });
  }
  
  function getContactModalNodes(sourceNode) {
      const scopedRoot = sourceNode && sourceNode.closest
          ? sourceNode.closest('[data-section-id], .shopify-section, body')
          : null;
  
      let contactForm = scopedRoot ? scopedRoot.querySelector(".modal-contact-for-availability") : null;
      let contactFormBackground = scopedRoot ? scopedRoot.querySelector(".contact-form-background") : null;
  
      if (!contactForm) {
          contactForm = document.querySelector(".modal-contact-for-availability");
      }
      if (!contactFormBackground) {
          contactFormBackground = document.querySelector(".contact-form-background");
      }
  
      return {
          contactForm,
          contactFormBackground
      };
  }
  
  function setContactModalVisibility(isOpen, sourceNode) {
      const nodes = getContactModalNodes(sourceNode);
      if (!nodes.contactForm) {
          return;
      }
  
      if (isOpen) {
          nodes.contactForm.classList.add("active-contact-form");
          if (nodes.contactFormBackground) {
              nodes.contactFormBackground.classList.add("active-contact-form-background");
          }
          if (document.body) {
              document.body.classList.add("active-contact-form-body");
          }
          return;
      }
  
      nodes.contactForm.classList.remove("active-contact-form");
      if (nodes.contactFormBackground) {
          nodes.contactFormBackground.classList.remove("active-contact-form-background");
      }
      if (document.body) {
          document.body.classList.remove("active-contact-form-body");
      }
  }
  
  document.addEventListener("click", (event) => {
      const openTrigger = event.target && event.target.closest
          ? event.target.closest(".btn-contact-for-availability")
          : null;
      if (openTrigger) {
          setContactModalVisibility(true, openTrigger);
          return;
      }
  
      const closeTrigger = event.target && event.target.closest
          ? event.target.closest(".contact-form-close, .contact-form-background")
          : null;
      if (closeTrigger) {
          setContactModalVisibility(false, closeTrigger);
      }
  });

  const COUNTRY_PLACEHOLDER_VALUE = "__select_country__";
  function populateCountrySelect(countrySelect, countriesData) {
      if (!countrySelect || countrySelect.dataset.countryOptionsInitialized === "true") {
          return;
      }
  
      if (countrySelect.options.length > 0) {
          countrySelect.dataset.countryOptionsInitialized = "true";
          return;
      }
  
      const defaultOption = document.createElement("option");
      defaultOption.value = COUNTRY_PLACEHOLDER_VALUE;
      defaultOption.textContent = "Select Country";
      defaultOption.disabled = true;
      defaultOption.selected = true;
      countrySelect.appendChild(defaultOption);
  
      const availableCountries = Array.isArray(countriesData) && countriesData.length
          ? countriesData
          : [
              { countryName: "United States" },
              { countryName: "Canada" }
          ];
  
      const otherCountries = availableCountries
          .filter((country) => (
              country.countryName !== "United States" &&
              country.countryName !== "Canada"
          ))
          .sort((a, b) => a.countryName.localeCompare(b.countryName));
  
      ["United States", "Canada"].forEach((countryName) => {
          const option = document.createElement("option");
          option.value = countryName;
          option.textContent = countryName;
          countrySelect.appendChild(option);
      });
  
      otherCountries.forEach((country) => {
          const option = document.createElement("option");
          option.value = country.countryName;
          option.textContent = country.countryName;
          countrySelect.appendChild(option);
      });
  
      countrySelect.dataset.countryOptionsInitialized = "true";
  }
  
  function initCountrySelectsFromNodes(countrySelects) {
      if (!countrySelects.length) {
          return;
      }
  
      loadCountryRegionData()
          .then((countriesData) => {
              countrySelects.forEach((countrySelect) => {
                  populateCountrySelect(countrySelect, countriesData);
              });
          })
          .catch(() => {
              countrySelects.forEach((countrySelect) => {
                  populateCountrySelect(countrySelect, []);
              });
          });
  }
  
  function syncSpecificationField(selectElement) {
      const $form = $(selectElement).closest("form");
      const specificationField = $form.find("#specification");
      if (!specificationField.length) {
          return;
      }
  
      const selectedValue = $(selectElement).val();
      if (selectedValue === "Other") {
          specificationField.attr("placeholder", "N/A");
      } else {
          specificationField.attr("placeholder", "which one");
      }
  
      if (
          selectedValue === "Event" ||
          selectedValue === "Location" ||
          selectedValue === "Other"
      ) {
          specificationField.show();
      } else {
          specificationField.hide();
      }
  }
  
  function syncLocationAnswerField(locationSelectElement) {
      const $form = $(locationSelectElement).closest("form");
      const locationAnswerField = $form.find("#locationAnswer");
      if (!locationAnswerField.length) {
          return;
      }
  
      if ($(locationSelectElement).val() === "Other") {
          locationAnswerField.attr("placeholder", "N/A");
          locationAnswerField.show();
      } else {
          locationAnswerField.hide();
      }
  }
  
  function initContactConditionalFieldsFromNodes(specificationSelects, locationSelects) {
      specificationSelects.forEach((selectElement) => {
          syncSpecificationField(selectElement);
      });
      locationSelects.forEach((locationSelectElement) => {
          syncLocationAnswerField(locationSelectElement);
      });
  }
  
  function initCfaRuntime(rootNode) {
      const runtimeNodes = collectCfaRuntimeNodes(rootNode);
      if (runtimeNodes.needsOptionSelection) {
          loadOptionSelectionScriptIfNeeded(rootNode, true);
      }
      if (runtimeNodes.countrySelects.length) {
          initCountrySelectsFromNodes(runtimeNodes.countrySelects);
      }
      if (runtimeNodes.specificationSelects.length || runtimeNodes.locationSelects.length) {
          initContactConditionalFieldsFromNodes(runtimeNodes.specificationSelects, runtimeNodes.locationSelects);
      }
  }
  
  function unloadCfaRuntime(rootNode) {
      if (!rootNode || !rootNode.querySelector || !rootNode.querySelector(".modal-contact-for-availability.active-contact-form")) {
          return;
      }
      setContactModalVisibility(false, rootNode);
  }
  
  window.__sternCfa = window.__sternCfa || {};
  window.__sternCfa.onSectionLoad = initCfaRuntime;
  window.__sternCfa.onSectionUnload = unloadCfaRuntime;
  
  if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
          initCfaRuntime(document);
      });
  } else {
      initCfaRuntime(document);
  }
  
  function setFieldValueById(fieldId, fieldValue) {
      const field = document.getElementById(fieldId);
      if (!field) return;
      field.value = fieldValue == null ? '' : String(fieldValue);
  }
  
  function getCfaReferrerType() {
      if (
          document.referrer.includes("sternpinball.com") ||
          document.referrer.includes("staging-sternpinball.kinsta.cloud")
      ) {
          return document.referrer.includes("shop.sternpinball.com") ? "Shopify" : "WP";
      }
      return "Shopify";
  }
  
  function initContactForAvailabilityPage() {
      if (!document.body || !document.body.classList.contains("page-contact-for-availability")) {
          return;
      }

      const params = new URLSearchParams(window.location.search);

      // ---- CFA dedicated-page conversion tracker ----
      // Shopify {% form 'contact' %} 302s to ?contact_posted=true on success.
      // Push the dataLayer event here so GTM trigger "Contact For Availability" (#96)
      // fires GA4 / Google Ads / Meta Lead / Reddit Lead.
      // sessionStorage dedupes against bf-cache, back/forward, and accidental reloads.
      // NOTE: requires GTM trigger #96 to have the "QP - contact_posted != true" exception removed.
      if (params.get("contact_posted") === "true") {
          try {
              const cfaDedupeKey = window.location.pathname + window.location.search;
              const cfaFiredKey = sessionStorage.getItem("cfa_page_fired");
              if (cfaFiredKey !== cfaDedupeKey) {
                  sessionStorage.setItem("cfa_page_fired", cfaDedupeKey);

                  const cfaEventId = (window.crypto && typeof window.crypto.randomUUID === "function")
                      ? window.crypto.randomUUID()
                      : (Date.now() + "-" + Math.random().toString(36).slice(2));

                  const cfaUtmMerged = (typeof window.__sternGetUtmMerged === "function")
                      ? (window.__sternGetUtmMerged() || {})
                      : {};
                  const cfaAttrApi = window.__sternAttributionApi || null;
                  const cfaCanonical = (cfaAttrApi && typeof cfaAttrApi.getCanonical === "function")
                      ? (cfaAttrApi.getCanonical() || {})
                      : {};
                  const cfaLastTouch = (cfaAttrApi && typeof cfaAttrApi.getLastTouch === "function")
                      ? (cfaAttrApi.getLastTouch() || {})
                      : {};

                  const cfaCampaign = (cfaCanonical.utm_campaign || cfaUtmMerged.utm_campaign || params.get("utm_campaign") || "");
                  const cfaIsCes = cfaCampaign.toLowerCase().includes("ces");
                  const cfaClickIds = (cfaAttrApi && typeof cfaAttrApi.getClickIds === "function")
                      ? (cfaAttrApi.getClickIds() || {})
                      : {};

                  if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
                      Shopify.analytics.publish("stern_contact_for_availability", {
                          event_id: cfaEventId,
                          submission_id: cfaEventId,
                          form_source: "cfa_page",
                          method: "form_submission",
                          page_path: window.location.pathname,
                          deal_source: cfaCanonical.deal_source || "",
                          canonical_source_origin: cfaCanonical.source_origin || "",
                          referrer_hostname: cfaLastTouch.referrer_hostname || "",
                          utm_source: cfaUtmMerged.utm_source || params.get("utm_source") || "",
                          utm_medium: cfaUtmMerged.utm_medium || params.get("utm_medium") || "",
                          utm_campaign: cfaUtmMerged.utm_campaign || params.get("utm_campaign") || "",
                          utm_content: cfaUtmMerged.utm_content || params.get("utm_content") || "",
                          utm_term: cfaUtmMerged.utm_term || params.get("utm_term") || "",
                          gclid: cfaClickIds.gclid || "",
                          dclid: cfaClickIds.dclid || "",
                          gbraid: cfaClickIds.gbraid || "",
                          wbraid: cfaClickIds.wbraid || "",
                          msclkid: cfaClickIds.msclkid || "",
                          fbclid: cfaClickIds.fbclid || "",
                          ttclid: cfaClickIds.ttclid || "",
                          twclid: cfaClickIds.twclid || "",
                          li_fat_id: cfaClickIds.li_fat_id || "",
                          pin_clickid: cfaClickIds.pin_clickid || "",
                          rdt_cid: cfaClickIds.rdt_cid || "",
                          first_touch_at: cfaCanonical.first_touch_at || "",
                          last_touch_at: cfaCanonical.last_touch_at || "",
                          ces_campaign: cfaIsCes ? "ces2026" : ""
                      });
                  }
              }
          } catch (cfaTrackErr) {
              // Never let tracking break the page.
              if (window.console && typeof console.warn === "function") {
                  console.warn("CFA page tracker failed:", cfaTrackErr);
              }
          }
      }

      const productHandle = params.get("product");
      const productPrice = params.get("price") || "";
      const productTitle = params.get("title") || "";
      const productVariant = params.get("variant") || "";
      const referrerType = getCfaReferrerType();

      setFieldValueById("shopType", referrerType);
  
      // If no product handle is provided, keep the page usable and prefill what we can.
      if (!productHandle) {
          setFieldValueById("contact-form-product-title", productTitle);
          setFieldValueById("contact-form-product-price", productPrice);
          setFieldValueById("variant", productVariant);
          setFieldValueById("ip_family", productTitle);
          setFieldValueById("product-url", window.location.href);
          return;
      }
  
      fetch(`/products/${productHandle}.json`)
          .then(response => {
              if (!response.ok) {
                  throw new Error(`HTTP error: ${response.status}`);
              }
              return response.json();
          })
          .then(data => {
              if (!data || !data.product) {
                  throw new Error("Invalid product payload");
              }
  
              const product = data.product;
              const variants = Array.isArray(product.variants) ? product.variants : [];
              const selectedVariant = variants.find(variant =>
                  variant &&
                  variant.title &&
                  productVariant &&
                  variant.title.toLowerCase().includes(productVariant.toLowerCase())
              );
  
              setFieldValueById("contact-form-product-title", product.title || productTitle);
              setFieldValueById("ip_family", product.title || productTitle);
              setFieldValueById("product-url", `https://shop.sternpinball.com/collections/games/products/${product.handle}`);
  
              if (selectedVariant) {
                  setFieldValueById("contact-form-product-price", selectedVariant.price || productPrice);
                  setFieldValueById("variant", selectedVariant.title || productVariant);
              } else {
                  setFieldValueById("contact-form-product-price", productPrice);
                  setFieldValueById("variant", productVariant);
              }
          })
          .catch(() => {
              setFieldValueById("contact-form-product-title", productTitle);
              setFieldValueById("contact-form-product-price", productPrice);
              setFieldValueById("variant", productVariant);
              setFieldValueById("ip_family", productTitle);
              setFieldValueById("product-url", `https://shop.sternpinball.com/products/${productHandle}`);
          });
  }
  
  if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initContactForAvailabilityPage);
  } else {
      initContactForAvailabilityPage();
  }
  
  $(document).on("change", "#select", function () {
      syncSpecificationField(this);
  });
  
  $(document).on("change", "#location", function () {
      syncLocationAnswerField(this);
  });
}

// [module] src/runtime/entries/scripts-cfa.mjs

registerLegacyScriptsCfaRuntime();

})();
